import AddToCart from "../cart/AddToCart";

export default class Favorites {
    public static addToFavorites(id: number, oncomplete?: (r: any) => void): void {
        $.ajax({
            url: '/favorites/' + id + '/add',
            type: 'POST',
            success: (r) => {
                oncomplete(r);
            },
        });
    }

    public static removeFromFavorites(id: number, oncomplete?: (r: any) => void): void {
        $.ajax({
            url: '/favorites/' + id + '/remove',
            type: 'POST',
            success: (r) => {
                oncomplete(r);
            },
        });
    }

    public static onFavoritesPage($uid: JQuery): void {
        $('.cart-products__item', $uid).each((ix, el) => {
            const $product = $(el);
            const id = $product.data('id');

            $('.remove', $product).on('click', () => {
                this.removeFromFavorites(id, (r) => {
                    const $all = $('.cart-products__item', $uid);

                    if ($all.length > 1) {
                        this.updateState(r);
                        $product.remove();
                    } else {
                        window.location.href = '/schowek';
                    }
                });
            });

            $('.add', $product).on('click', () => {
                AddToCart.addToCart('product:' + id, 1);
            });
        });

        $('.js-selectall').on('click', () => {
            const $items = $('.cart-products__item', $uid);

            $('.input__input--checkbox', $items).prop('checked', true);
        });

        $('.js-removeselected').on('click', () => {
            const $all = $('.cart-products__item', $uid);
            const $items = $all.filter(':has(.input__input--checkbox:checked)');

            let done = 0;

            $items.each((ix, el) => {
                const $product = $(el);
                const id = $product.data('id');

                this.removeFromFavorites(id, (r) => {
                    done ++;

                    if (done == $items.length) {
                        if ($items.length == $all.length) {
                            window.location.href = '/schowek';
                        } else {
                            this.updateState(r);
                            $items.remove();
                        }
                    }
                });
            });
        });

        $('.js-addselected').on('click', () => {
            const $all = $('.cart-products__item', $uid);
            const $items = $all.filter(':has(.input__input--checkbox:checked)');

            let done = 0;

            $items.each((ix, el) => {
                const $product = $(el);
                const id = $product.data('id');

                AddToCart.addToCart('product:' + id, 1, () => {
                    done ++;

                    if (done == $items.length) {
                        window.location.href = '/cart/';
                    }
                }, false);
            });
        });
    }

    private static updateState(r: any): void {
        const $fav = $('.header__controls-fav');
        $fav.addClass('flash');

        setTimeout(() => {
            $fav.removeClass('flash')
        }, 1000);

        $('.totalquantityinfo', $fav).text(r.count);
    }

    public static initFavButton($uid: JQuery): void {
        const id = $uid.data('id');

        (<any> $uid).tooltip({
            title: () => {
                if ($uid.hasClass('button--favadded')) {
                    return 'usuń ze schowka';
                } else {
                    return 'do schowka';
                }
            },

            trigger: 'hover',
            placement: 'right',
        });

        $uid.on('click', (e) => {
            (<any> $uid).tooltip('hide');

            const oncomplete = (r) => {
                this.updateState(r);
                $uid.toggleClass('button--favadded', r.favorite);
            };

            if ($uid.hasClass('button--favadded')) {
                this.removeFromFavorites(id, oncomplete);
            } else {
                this.addToFavorites(id, oncomplete);
            }
        });
    }
}
